import { Component,ViewChildren,ElementRef,QueryList,ChangeDetectorRef} from '@angular/core';
import { AppState } from '../../../../app/app.global';
import { HttpService } from '../../../../providers/service/httpservice';
import { GETWEEKBYDATE,GETLESSONS } from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';
import { Utils } from '../../../../providers/service/utils';
 

@Component({
  selector: 'classscheule-page',
  templateUrl: 'classschedule.html'
})

export class ClassSchedule {
  week:any=[];
  weekInfo:any;
  weekNumber:string;//周次
  weekNum;//星期几
  currDate:Date;
  user:any;
  lessonsData:any;
  lessonsList:any = [{"lessons":[]},{"lessons":[]},{"lessons":[]},{"lessons":[]},{"lessons":[]},
  		{"lessons":[]},{"lessons":[]}, {"lessons":[]},{"lessons":[]},{"lessons":[]}];
  @ViewChildren('weekDay')
  weekDayItems: QueryList<ElementRef>;
	constructor(public global: AppState,private httpService:HttpService,private changeDetectorRef:ChangeDetectorRef  ) {
		this.user = StorageService.getObj('currentUser');
		this.weekInfo = StorageService.getObj('weekInfo');
		this.currDate = new Date();
		let cDate = Utils.dateFormat(this.currDate,'yyyy/MM/dd');
		this.httpService.get(GETWEEKBYDATE,{"cDate":cDate}).then(anyObj => this.handleWeeklyData(anyObj));
	}
	handleWeeklyData(obj:any){
  	if(obj){
  	 this.weekInfo = obj;
  	 StorageService.setObj("weekInfo",this.weekInfo);
     this.weekNumber = obj.weekly;
     let fWeekly = obj.startDate;
     this.week = [];
     this.week.push({"weekTitle":"#","weekDate":"#"})
     for( let i = 1;i <= 7;i++){
     	let item = {};
	    switch(i)
	     	{
	     		case 1:
	     		item = {"weekTitle":"周一","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 2:
	     		item = {"weekTitle":"周二","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 3:
	     		item = {"weekTitle":"周三","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 4:
	     		item = {"weekTitle":"周四","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 5:
	     		item = {"weekTitle":"周五","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 6:
	     		item = {"weekTitle":"周六","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     		case 7:
	     		item = {"weekTitle":"周日","weekDate":Utils.dateFormat(new Date(fWeekly),'MM/dd')};
	     		break;
	     	}
	    this.week.push(item);
	    let d = new Date(fWeekly);
	    fWeekly = Utils.dateFormat(new Date(+d+1000*60*60*24),'yyyy/MM/dd');
     }
     this.changeDetectorRef.markForCheck();  
     this.changeDetectorRef.detectChanges(); 
     this.weekNum = this.currDate.getDay();
     this.selectWeekDay(this.weekDayItems["_results"][this.weekNum].nativeElement,this.weekNum);
  	}
 }
	
  selectWeekDay(weekDay:any,i:number){
      if(i != 0){
      	let $this = weekDay;
      	$this.classList.add("active");
      	let elem = $this.parentNode.firstChild;
      	for ( ; elem; elem = elem.nextSibling ) {
  	  	if ( elem.nodeType === 1 && elem !== $this) {
  	  		  elem.classList.remove('active');
  	  	  }
  	    }
      	let coe= i - this.weekNum;
      	this.weekNum = i;
      	let d = new Date(this.currDate);
      	this.currDate = new Date(+d+coe*1000*60*60*24);
      	this.getLessonList();
      }else{
      	return;
      }
  }
  
  getLessonList(){
  	let param = {"hd":this.user.hd,"sYear":this.weekInfo.sYear,"semeter":this.weekInfo.semeter,
  	"weekly":this.weekInfo.weekly,"weekDay":this.weekNum,"role":this.user.role};
  	this.httpService.get(GETLESSONS,param).then(anyObj => this.handleLesssonsData(anyObj));
  }
  
  handleLesssonsData(obj){
  	this.lessonsList = [{"lessons":[]},{"lessons":[]},{"lessons":[]},{"lessons":[]},{"lessons":[]},
  		{"lessons":[]},{"lessons":[]}, {"lessons":[]},{"lessons":[]},{"lessons":[]}];

  	if(obj&&obj.length>0){
  		for(let i = 0;i < obj.length;i++){
  			let index = Number(obj[i].lessonNum)-1;
  			this.lessonsList[index].lessons.push(obj[i]);
  		}
  	}
  }
  
  preWeek(){
  	let d = new Date(this.currDate);
  	this.currDate = new Date(+d-7*1000*60*60*24);
  	let cDate = Utils.dateFormat(this.currDate,'yyyy/MM/dd');
  	this.httpService.get(GETWEEKBYDATE,{"cDate":cDate}).then(anyObj => this.handleWeeklyData(anyObj));
  }
  nextWeek(){
  	let d = new Date(this.currDate);
  	this.currDate = new Date(+d+7*1000*60*60*24);
    let cDate = Utils.dateFormat(this.currDate,'yyyy/MM/dd');
	this.httpService.get(GETWEEKBYDATE,{"cDate":cDate}).then(anyObj => this.handleWeeklyData(anyObj));
  }
  loadMore(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 500);
  }
  //下拉刷新
  doRefresh(refresher){
    setTimeout(() => {
      refresher.complete();
    }, 1000);
  }
}


// WEBPACK FOOTER //
// ./src/pages/application/teaching/classschedule/classschedule.ts